import React, { useState, useEffect } from "react";
import { Box, Button, Divider, Chip } from "@mui/material";
import AvailableJob from "./subTable/AvailableJob";
import AllBatches from "./subTable/AllBatch";
import Completed from "./subTable/Completed";
import Accepted from "./subTable/Accepted";
import Incomplete from "./subTable/Incomplete";
import NotAccepted from "./subTable/NotAccepted";
import axios from "axios";
import { useParams } from "react-router-dom";
import ModalToCreateJobBatches from "../ModalToCreateJobBatches";
import { Snackbar, Alert } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import AddJobDialog from "./addJobModal";

const JobsActionPanel = ({
  isDisabled,
  // openModalToCreateJobBatches,
  // setOpenModalToCreateJobBatches,
}) => {
  const { id } = useParams();
  const [soDetails, setSoDetails] = React.useState([]);
  const [productDetails, setProductDetails] = React.useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [availableJobs, setAvailableJobs] = React.useState([]);
  const [availableBatches, setAvailableBatches] = React.useState([]);
  const [allPublish, setAllPublish] = React.useState(false);
  const [acceptedBatches, setAcceptedBatches] = useState([]);
  const [isPublishDisabled, setIsPublishDisabled] = useState(false);
  const [openAddJob, setOpenAddJob] = useState(false);
  const [openModalToCreateJobBatches, setOpenModalToCreateJobBatches] =
    useState(false);
  const serviceName = "Recce";
  const serviceType = 0;
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [selectedBatchIds, setSelectedBatchIds] = React.useState([]);

  const filters = [
    "Available Jobs",
    "All Batches",
    "Incomplete",
    "Not Accepted",
    "Accepted",
    "Completed",
  ];

  const actions = [
    // "Create Lots Manually",

    "Create Batches",
    "Publish Selected Batches",
    // "Create Jobs",
  ];

  const [selectedFilter, setSelectedFilter] = useState("Available Jobs");
  const [activeTable, setActiveTable] = useState("Available Jobs");
  const [totalBatches, setTotalBatches] = useState(0);
  const [totalCompletedBatches, setTotalCompletedBatches] = useState(0);
  const [totalAcceptedBatches, setTotalAcceptedBatches] = useState(0);
  const [totalNotAcceptedBatches, setTotalNotAcceptedBatches] = useState(0);
  const [totalIncompleteBatches, setTotalIncompleteBatches] = useState(0);
  const [forbatch, setForBatch] = useState([]);
  const [completedBatches, setCompletedBatches] = useState([]);
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isNotAccepted, setIsNotAccepted] = useState([]);
  const [allJobsBasedLoading, setAllJobsBasedLoading] = useState(false);
  const [isAllBatchesLoading, setAllBatchesLoading] = useState(false);

  const fetchBatchById = async (batchId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/batchOfJobs/getBatchJobById/${batchId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response?.data?.success) {
        return response?.data?.data;
      }
      return null;
    } catch (error) {
      console.error("Error fetching batch:", error);
      return null;
    }
  };

  const fetchDataBasedOnFilter = async (filter) => {
    if (filter === "Available Jobs") {
      await fetchAllJobsBasedOnCampaignId();
    } else if (filter === "All Batches") {
      await fetchAllBatchesBasedOnCampaignId();
    }

    // else if (filter === "Incomplete") {
    //   await fetchAcceptedBatches();
    // } else if (filter === "Not Accepted") {
    //   await fetchAcceptedBatches();
    // } else if (filter === "Accepted") {
    //   await fetchAcceptedBatches();
    // } else if (filter === "Completed") {
    //   await fetchAcceptedBatches();
    // }
  };

  // Handle the filter click to change the filter and fetch data
  const handleFilterClick = (filter) => {
    setSelectedFilter(filter);
    setActiveTable(filter);

    // Trigger the API call to fetch updated data based on the selected filter
    fetchDataBasedOnFilter(filter);
  };

  // good code practice
  const fetchAllJobsBasedOnCampaignId = async () => {
    try {
      setAllJobsBasedLoading(true);

      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not found in localStorage");
        return;
      }

      const response = await axios.get(
        `${
          process.env.REACT_APP_URL
        }/jobs/allAvailableJobsForRecce?campaignId=${id}&serviceType=${0}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (response?.data?.success && Array.isArray(response.data.data)) {
        setAvailableJobs(response.data.data);
        setSoDetails(response.data.soDetails);
        setProductDetails(response.data.productDetails);
        setCategoryData(response.data.categoryWithProducts || []);
      } else {
        console.warn("Unexpected API response", response);
        setAvailableJobs([]); // Clear if response is malformed
      }
    } catch (error) {
      console.error("Error while fetching jobs", error);
      setAvailableJobs([]); // Optional fallback
    } finally {
      setAllJobsBasedLoading(false);
    }
  };

  // Fetch available Batches
  const fetchAllBatchesBasedOnCampaignId = async () => {
    setAllBatchesLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/jobs/allBatchesForRecce?campaignId=${id}&serviceType=0`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        const AllBatchesInRecce = response.data.data; // Now the server returns only Recce batches
        // Update all relevant states
        setAvailableBatches(response.data.data);

        // Update accepted batches
        const filteredAcceptedBatches = AllBatchesInRecce.filter(
          (batch) => batch.installationPartnerId,
        );
        setAcceptedBatches(filteredAcceptedBatches);

        // Update not accepted batches
        const notAcceptedBatches = AllBatchesInRecce.filter(
          (batch) => !batch.installationPartnerId,
        );
        setIsNotAccepted(notAcceptedBatches);
        setAllBatchesLoading(false);
        const allPublished = AllBatchesInRecce.every(
          (batch) => batch.isPublished == true,
        );
        setAllPublish(allPublished);
        setTotalBatches(AllBatchesInRecce.length); // Update total batches count
        setSelectedBatchIds([]); // Reset selection when batches are refreshed
      }
    } catch (error) {
      setAllBatchesLoading(false);
      console.error("error in while fetching jobs", error);
    }
  };

  // Fetch accepted batches for the "Accepted" filter
  const fetchAcceptedBatches = async () => {
    setAllBatchesLoading(true);
    try {
      const response = await axios.get(
        `${
          process.env.REACT_APP_URL
        }/batchOfJobs/getAllBatchJobs?campaignId=${id}&serviceType=${"0"}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response?.data?.success) {
        const allBatches = response.data.data;

        // Filter for Not Accepted batches (no IP or IP is null)
        const notAcceptedBatches = allBatches.filter(
          (batch) =>
            (!batch.installationPartnerId ||
              batch.installationPartnerId === null) &&
            batch.serviceType == "0",
        );

        setIsNotAccepted(notAcceptedBatches);
        // Filter for Accepted batches (has IP)
        const filteredAcceptedBatches = allBatches.filter(
          (batch) => batch.installationPartnerId,
          // batch.installationPartnerId.trim() !== ""
        );

        setAcceptedBatches(filteredAcceptedBatches);
      }
    } catch (error) {
      console.error("Error while fetching accepted batches", error);
    } finally {
      setAllBatchesLoading(false);
    }
  };

  const updateJob = async (job) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${job._id}`,
        job,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data; // Return the updated job data
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  //FUNCTION: Reject a job
  const rejectJob = async (jobIds, reason) => {
    if (!reason?.trim()) {
      throw new Error("Rejection reason is required");
    }

    const normalizedJobIds = Array.isArray(jobIds) ? jobIds : [jobIds];

    try {
      const token = localStorage.getItem("token");
      const userId = localStorage.getItem("userId");

      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/cancelJobRequestedByIP`,
        {
          jobId: normalizedJobIds, // Send as array
          approvedBy: userId,
          rejectionReason: reason.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.data.success) {
        throw new Error(response.data.message || "Failed to reject job");
      }

      return response.data;
    } catch (error) {
      console.error("Error rejecting job:", error);
      if (error.response) {
        console.error("Error details:", {
          status: error.response.status,
          data: error.response.data,
        });
      }
      throw error;
    }
  };

  React.useEffect(() => {
    if (id) {
      fetchDataBasedOnFilter(selectedFilter);
    }
  }, [id]);
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Handle action clicks
  const handleActionClick = async (action) => {
    if (action === "Create Batches") {
      // Check if no jobs are selected
      if (selectedJobs.length === 0) {
        setSnackbar({
          open: true,
          message: "Please select at least one job to create batches",
          severity: "warning",
        });
        return;
      }
      setOpenModalToCreateJobBatches(true);
    }
    if (action === "Publish Selected Batches") {
      if (selectedBatchIds.length === 0) {
        setSnackbar({
          open: true,
          message: "Please select at least one batch to publish",
          severity: "warning",
        });
        return;
      }

      try {
        setIsPublishDisabled(true);
        const token = localStorage.getItem("token");
        const responseFromSaving = await axios.post(
          `${process.env.REACT_APP_URL}/batchOfJobs/publishBatches`,
          {
            batchIds: selectedBatchIds,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        if (responseFromSaving?.data.success) {
          setIsPublishDisabled(false);
          fetchAllBatchesBasedOnCampaignId();
          setSelectedBatchIds([]);
          setSnackbar({
            open: true,
            message: `${responseFromSaving.data.message}`,
            severity: "success",
          });
        }
      } catch (error) {
        setIsPublishDisabled(false);
        console.error("Error while saving created batches", error);
        setSnackbar({
          open: true,
          message: "Error publishing batches",
          severity: "error",
        });
      }
    }
  };

  // Conditionally render actions based on the selected filter
  const filteredActions = actions.filter((action) => {
    if (
      selectedFilter === "Available Jobs" &&
      action === "Publish Selected Batches"
    ) {
      return false; // Remove "Publish Selected Batches" for Available Jobs
    }
    if (selectedFilter === "Not Accepted" && action === "Create Batches") {
      return false; // Remove "Create Lots Automatically" for Not Accepted
    }
    if (
      selectedFilter === "All Batches" &&
      action !== "Publish Selected Batches"
    ) {
      return false; // Only show "Publish Selected Batches" for All Batches
    }
    return true; // Include other actions as normal
  });

  return (
    <div>
      {/* Divider */}
      <Divider sx={{ marginBottom: "1rem" }} />

      {/* Filters and Actions Container */}
      <div
        className="flex flex-wrap justify-between items-center gap-4"
        style={{
          display: "flex",
          flexWrap: "wrap",
          marginBottom: "1rem",
          marginLeft: "1rem",
          marginRight: "1rem",
        }}
      >
        {/* Filters and Actions Container */}
        {/* Left Section: Filters */}
        <div
          className="filters-section"
          style={{ flex: 1, display: "flex", gap: "8px", flexWrap: "wrap" }}
        >
          {filters.map((filter) => (
            <Button
              variant="outlined"
              key={filter}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: selectedFilter === filter ? "white" : "black",
                borderColor:
                  selectedFilter === filter ? "transparent" : "#d9dadb",
                backgroundColor:
                  selectedFilter === filter ? "black" : "transparent",
                "&:hover": {
                  backgroundColor:
                    selectedFilter === filter ? "black" : "transparent",
                  borderColor:
                    selectedFilter === filter ? "transparent" : "#d9dadb",
                },
              }}
              onClick={() => handleFilterClick(filter)}
            >
              {filter}
            </Button>
          ))}
        </div>
        {/* Right Section: Total Jobs Count + Create Batches */}
        <Box display="flex" alignItems="center" gap={2}>
          {selectedFilter === "Available Jobs" && (
            <Chip
              label={`Total Jobs Available: ${availableJobs.length}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "All Batches" && (
            <>
              <Chip
                label={`Total Batches: ${totalBatches}`}
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: "400",
                  padding: "6px 12px",
                  backgroundColor: "transparent",
                  border: "1px solid #d9dadb",
                  color: "black",
                }}
              />
            </>
          )}
          {selectedFilter === "Completed" && (
            <Chip
              label={`Total Completed Batches: ${totalCompletedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Accepted" && (
            <Chip
              label={`Total Accepted Batches: ${totalAcceptedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Not Accepted" && (
            <Chip
              label={`Total Not Accepted Batches: ${totalNotAcceptedBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}
          {selectedFilter === "Incomplete" && (
            <Chip
              label={`Total Incomplete Batches: ${totalIncompleteBatches}`}
              sx={{
                fontSize: "0.8rem",
                fontWeight: "400",
                padding: "6px 12px",
                backgroundColor: "transparent",
                border: "1px solid #d9dadb",
                color: "black",
              }}
            />
          )}

          {/* Create Batches Button */}
          {selectedFilter === "Available Jobs" && (
            <>
              <Button
                variant="outlined"
                sx={{
                  fontSize: "0.8rem",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "4px 12px",
                  color: "#418cff",
                  borderColor: "#418cff",
                  backgroundColor: "transparent",
                }}
                onClick={() => setOpenAddJob(true)}
              >
                Add Jobs
              </Button>
              <Button
                key="Create Batches"
                variant="outlined"
                disabled={
                  isDisabled === "recce" ||
                  selectedFilter !== "Available Jobs" ||
                  availableJobs.length === 0
                }
                sx={{
                  fontSize: "0.8rem",
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "4px 12px",
                  color:
                    isDisabled === "recce" || availableJobs.length === 0
                      ? "black"
                      : "#418cff",
                  borderColor: "#418cff",
                  backgroundColor:
                    isDisabled === "recce" || availableJobs.length === 0
                      ? "#d9dadb"
                      : "transparent",
                  "&:hover": {
                    backgroundColor:
                      isDisabled === "recce" || availableJobs.length === 0
                        ? "#d9dadb"
                        : "rgba(65, 140, 255, 0.1)",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#d9dadb",
                    color: "black",
                    borderColor: "#d9dadb",
                  },
                }}
                onClick={() => handleActionClick("Create Batches")}
              >
                Create Batches
              </Button>
            </>
          )}
          {selectedFilter === "All Batches" && (
            <Button
              key="Publish Selected Batches"
              variant="outlined"
              // disabled={
              //   isDisabled === "recce" ||
              //   selectedFilter !== "All Batches" ||
              //   availableJobs.length === 0
              // }
              disabled={allPublish}
              sx={{
                fontSize: "0.8rem",
                textTransform: "none",
                borderRadius: "8px",
                padding: "4px 12px",
                color: "#418cff",
                borderColor: "#418cff",
                backgroundColor: "transparent",
              }}
              onClick={() =>
                isPublishDisabled
                  ? null
                  : handleActionClick("Publish Selected Batches")
              }
            >
              {isPublishDisabled
                ? "Publish Selected Batches..."
                : "Publish Selected Batches"}
            </Button>
          )}
        </Box>
        <Snackbar
          open={snackbar.open}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            icon={
              snackbar.severity === "success" ? (
                <CheckCircleIcon sx={{ color: "white" }} />
              ) : (
                <ErrorIcon sx={{ color: "white" }} />
              )
            }
            sx={{
              backgroundColor:
                snackbar.severity === "success" ? "green" : "red",
              color: "white",
              display: "flex",
              alignItems: "center",
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>

      {/* Dynamic Table Rendering */}
      <Box sx={{ marginTop: "1rem" }}>
        {activeTable === "Available Jobs" && (
          <AvailableJob
            setAvailableJobs={setAvailableJobs}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
            selectAll={selectAll}
            setSelectAll={setSelectAll}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            allJobsBasedLoading={allJobsBasedLoading}
            availableJobs={availableJobs}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = availableJobs.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setAvailableJobs(updatedJobs);
            }}
            rejectJob={rejectJob}
            showSnackbar={setSnackbar}
          />
        )}
        {activeTable === "All Batches" && (
          <AllBatches
            availableBatches={availableBatches}
            setAvailableBatches={setAvailableBatches}
            availableJobs={forbatch}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = forbatch.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setForBatch(updatedJobs);
            }}
            isAllBatchesLoading={isAllBatchesLoading}
            selectedBatchIds={selectedBatchIds}
            setSelectedBatchIds={setSelectedBatchIds}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            productDetails={productDetails}
            categoryData={categoryData}
            soDetails={soDetails}
            rejectJob={rejectJob}
            showSnackbar={setSnackbar}
            fetchBatchById={fetchBatchById}
          />
        )}
        {activeTable === "Incomplete" && (
          <Incomplete
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            id={id}
            setTotalIncompleteBatches={setTotalIncompleteBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            updateJob={updateJob}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = availableJobs.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setAvailableJobs(updatedJobs);
            }}
            setIsNotAccepted={setIsNotAccepted}
            rejectJob={rejectJob}
            showSnackbar={setSnackbar}
            fetchBatchById={fetchBatchById}
          />
        )}
        {activeTable === "Not Accepted" && (
          <NotAccepted
            id={id}
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            isNotAccepted={isNotAccepted}
            setAcceptedBatches={setAcceptedBatches}
            matchingJobs={forbatch}
            setTotalNotAcceptedBatches={setTotalNotAcceptedBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            setIsNotAccepted={setIsNotAccepted}
            rejectJob={rejectJob}
            showSnackbar={setSnackbar}
            fetchBatchById={fetchBatchById}
          />
        )}
        {/* {activeTable === "Accepted" && <Accepted />} */}
        {activeTable === "Accepted" && (
          <Accepted
            id={id}
            updateJob={updateJob}
            isAllBatchesLoading={isAllBatchesLoading}
            setAvailableBatches={setAvailableBatches}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            updateJobInParent={(updatedJob) => {
              const updatedJobs = availableJobs.map((job) =>
                job._id === updatedJob._id ? updatedJob : job,
              );
              setAvailableJobs(updatedJobs);
            }}
            setTotalAcceptedBatches={setTotalAcceptedBatches}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            fetchAllBatchesBasedOnCampaignId={fetchAllBatchesBasedOnCampaignId}
            rejectJob={rejectJob}
            showSnackbar={setSnackbar}
            fetchBatchById={fetchBatchById}
          />
        )}
        {activeTable === "Completed" && (
          <Completed
            id={id}
            isAllBatchesLoading={isAllBatchesLoading}
            acceptedBatches={acceptedBatches}
            setAcceptedBatches={setAcceptedBatches}
            forbatch={forbatch}
            setTotalCompletedBatches={setTotalCompletedBatches}
            fetchBatchById={fetchBatchById}
          />
        )}

        {openModalToCreateJobBatches && (
          <ModalToCreateJobBatches
            serviceTypeDynamic={serviceType}
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
            campaignData={id}
            availableJobs={availableJobs}
            setSelectedJobs={setSelectedJobs}
            selectedJobs={selectedJobs}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            serviceName={serviceName}
            setSnackbar={setSnackbar}
            setIsNotAccepted={setIsNotAccepted}
          />
        )}
        {openAddJob && (
          <AddJobDialog
            open={openAddJob}
            onClose={() => setOpenAddJob(false)}
            campaignId={id}
            soDetails={soDetails}
            productDetails={productDetails}
            categoryData={categoryData}
            fetchAllJobsBasedOnCampaignId={fetchAllJobsBasedOnCampaignId}
            createJobFrom={"jobs"}
            jobForWhichService="Recce"
          />
        )}
      </Box>
    </div>
  );
};

export default JobsActionPanel;
